import type { FC } from 'react'
import { useCheckout } from '../../../CheckoutProvider'
import AttentionBox from '@g4g/ui/src/components/AttentionBox'

const CheckoutPaymentHodlAttention: FC = () => {
  const { lockedPrpsAmountNeeded, error } = useCheckout()

  return (
    <>
      {/* ERC20: something went wrong when calling getBalance */}
      {error ? (
        <AttentionBox>{error}</AttentionBox>
      ) : (
        <>
          {lockedPrpsAmountNeeded && (
            <AttentionBox info>
              {lockedPrpsAmountNeeded} locked PRPS will be burned to complete the transaction
            </AttentionBox>
          )}
        </>
      )}
    </>
  )
}

export default CheckoutPaymentHodlAttention
